import { useEffect, useMemo, useState } from 'react';
import { OrderStatus } from '@/types';
import { useAppSelector } from '@/hooks';
import ThanksView from '@/pages/order-status/components/ThanksView';
import StatusView from '@/pages/order-status/components/StatusView';
import { CircularProgress, Stack } from '@mui/material';
import useRoutes from '@/hooks/useRoutes';

const ALLOWED_STATUSES = [OrderStatus.REVIEWING, OrderStatus.PREPARING, OrderStatus.SENDING];

const OrderStatusPage = () => {
  const [navigate] = useRoutes();
  const order = useAppSelector((state) => state.order);
  const [remainingTime, setRemainingTime] = useState(0);

  const visibleView = useMemo(() => {
    if (!order?.createdBy) return 'loading';
    if (ALLOWED_STATUSES.includes(order?.status)) return 'status'
    return 'thanks';
  }, [order?.createdBy, order?.status])

  useEffect(() => {
    const interval = setInterval(() => {
        setRemainingTime((prev) => {
            if (prev <= 5) {
                return prev + 1
            }
            return prev;
        });
    }, 1000);
    
    return () => {
        clearInterval(interval);
    }
  }, [])

  useEffect(() => {
    if (remainingTime >= 5 && visibleView === 'loading') {
      navigate('organizations.menu.main');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visibleView, remainingTime])

  switch(visibleView){
    case 'status':
      return <StatusView />;
    case 'thanks':
      return <ThanksView />;
    default:
      return (
        <Stack flex={1} alignItems="center" px={3} py={6}>
          <CircularProgress />
        </Stack>
      )
  }
};

export default OrderStatusPage;
